import React from 'react'
import './exportTableContainer.css'
import { useSelector } from 'react-redux'
import CsvSymbole3Icon from './../../assets/images/filterArtwork/CsvSymbol3.png'

function generateCsvHref(data) {
	var sep = ';' //us version uses ',' no solution to that problem?
	var endOfLine = '\n'
	var charset = 'utf-8'

	var csvFormattedDataTable = ''
	csvFormattedDataTable += '\uFEFF'

	//add data
	data.forEach((row) => {
		const rowLine = row
			.map((e) => {
				if (typeof e === 'string') {
					return JSON.stringify(e)
				}
				return e
			})
			.join(sep)
		csvFormattedDataTable += rowLine + endOfLine
	})

	var encodedUri =
		'data:application/csv;charset=' +
		charset +
		',' +
		encodeURIComponent(csvFormattedDataTable)
	return encodedUri
}

function ExportTableContainer({
	searchParams,
	loadedData,
	findArtistFullName,
	findOwnerFullName,
}) {
	const pex = useSelector((state) => state.user.value.pex)
	const read_owner = pex.read_owner || pex.read_owner_names
	const read_artist = pex.read_artist || pex.read_artist_names
	const noPermissionText = 'Keine Berechtigung'

	function getFilename(ownerId = -1, artistId = -1, title = '') {
		const prefix = 'sucheKuenstwerke'

		const currentTime = new Date()
		//getMonth returns
		const formatedTime =
			currentTime.getDate() +
			'.' +
			(currentTime.getMonth() + 1) +
			'.' +
			currentTime.getFullYear()

		let searchParams = ''

		if (ownerId !== -1) {
			searchParams += 'Besitzer=' + findOwnerFullName(ownerId)
		}

		if (artistId !== -1) {
			if (searchParams !== '') {
				searchParams += '&'
			}
			searchParams += 'Kuenstler=' + findArtistFullName(artistId)
		}

		if (title !== '') {
			if (searchParams !== '') {
				searchParams += '&'
			}
			searchParams += "Titel='" + title + "'"
		}

		const endResult = prefix + '_' + searchParams + '_' + formatedTime + '.csv'

		return endResult
	}

	function getCsvData(loadedData) {
		// explicit columns in the desired order
		const headers = [
			'Werk-ID',
			'Bildtitel',
			'Kuenstler',
			'Besitzer',
			'Datierung',
			'Technik',
			'HxW mit Rahmen',
			'Ausstellungen',
		]

		var data = []
		data.push(headers)

		if (Array.isArray(loadedData) && loadedData.length > 0) {
			for (let i = 0; i < loadedData.length; i++) {
				const d = loadedData[i]
				const ownerId = d.ownerId
				const artistName = read_artist
					? findArtistFullName(d.artistId)
					: noPermissionText
				const ownerName = read_owner
					? findOwnerFullName(ownerId)
					: noPermissionText

				const row = [
					d.id,
					d.title_description || '',
					artistName,
					ownerName,
					d.dating || '',
					d.technik || '',
					d.HxW_with_Border || d.HxW_without_Border || '',
					d.exhibitions || '',
				]
				data.push(row)
			}
		} else {
			data = [['Was ist die Vokalpolyphonie?']]
		}

		return data

		//connectElementWithCsvFile(buttonId, filename, data);
	}

	const csvData = getCsvData(loadedData)
	const csvHref = generateCsvHref(csvData)
	const { ownerId, artistId, title } = searchParams
	const filename = getFilename(ownerId, artistId, title)
	return (
		<div id='exportTableContainer'>
			<div id='exportTableLabel'> Tabelle exportieren: </div>
			<a
				className='createFileContainer'
				id='createCsvFile'
				href={csvHref}
				download={filename}
				target='_blank'
				style={!loadedData.length ? { pointerEvents: 'none' } : {}}
			>
				<img src={CsvSymbole3Icon} className='createFileImage'></img>
			</a>
			<div id='exportTablePostLabel'>
				(Tabelle wird als Csv-Datei gespeichert und kann mit Excel bearbeitet
				und anschließend als xlsx-Datei gespeichert werden)
			</div>
		</div>
	)
}

export default ExportTableContainer
